import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router } from '@angular/router';
import { MeetingService } from '../../services/meeting.service';
import { ToasterService} from 'angular2-toaster';
import { EmailValidator } from '../validators/email_validator';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CookieService } from 'angular2-cookie/services/cookies.service';

declare var document: any;
declare var $: any;

@Component({
  selector: 'app-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.css']
})
export class UpdateComponent implements OnInit {

  busy: Promise<any>;
  userdata: any = [];
  authcode: any;
  user: any = [];
  avail_hours: any;
  f_name: any;
  l_name: any;
  email: any;
  city: any = [];
  c_name: any;
  phone: any;
  // pass: any;
  d_city: any = 0;
  error: any;
  regform: FormGroup;
  submitAttempt: boolean;

  constructor(
    private storage: LocalStorageService,
    public router: Router,
    public meetingService: MeetingService,
    private toasterService: ToasterService,
    public formBuilder: FormBuilder,
    private _cookieService: CookieService) {

    const val = this.storage.get('user');
    if (val) {
      this.user = val;
      // // console.log(this.user);
      this.avail_hours = val[0].hours;
      this.authcode = val[0].authcode;
    } else {
      const link = ['/login'];
      this.router.navigate(link);
    }

    this.regform = formBuilder.group({
        f_name: ['', Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*'), Validators.required])],
        l_name: ['', Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*'), Validators.required])],
        email: ['', Validators.compose([Validators.required, EmailValidator.isValid])],
        c_name: ['', Validators.required],
        d_city: [],
        phone: ['', Validators.required]
    });

    this.getUserdata();
  }

  ngOnInit() {

  }

  getUserdata() {
    this.busy = this.meetingService.getUserdata(this.authcode).subscribe(response => {
      if (response) {
        if (+ response.success === -1) {
          this.logOut(response.message);
        } else {
        // console.log(response);
        this.userdata = response;
        this.f_name = this.userdata[0].firstname;
        this.l_name = this.userdata[0].lastname;
        this.c_name = this.userdata[0].companyname;
        this.email = this.userdata[0].email;
        this.phone = this.userdata[0].phone;
        this.d_city = this.userdata[0].defaultcity;
        this.getCity();
      }
      } else {
        // console.log("error");
      }
    });
  }

  getCity() {
    this.busy = this.meetingService.getCity(this.authcode).subscribe(response => {
      if (response) {
        if (+ response.success === -1) {
          this.logOut(response.message);
        } else {
        this.city = response;
        // // console.log(this.city);
        this.getavailHours();
      }
      } else {
        // console.log("error");
      }
    });
  }

  updateUser() {
    this.submitAttempt = true;
    if (!this.regform.valid) {
        // console.log("not valid");
    } else {
    // // console.log(this.f_name);
    this.busy = this.meetingService.updateUser(this.authcode, this.f_name, this.l_name, this.c_name, this.email, this.phone, this.d_city)
      .subscribe(response => {
        if (response) {
          if (+ response.success === -1) {
            this.logOut(response.message);
          } else {
          // console.log(response);
          if (response.success === 1) {
            this._cookieService.put('updt_msg', response.message);
            const link = ['/profile'];
            this.router.navigate(link);
          } else {
            this.error = response.message;
            window.scrollTo(0, 0);
          }
        }
        } else {
          // console.log("error");
        }
    });
    }
  }

  getavailHours() {
    this.meetingService.getavailHours(this.authcode).subscribe(response => {
      if (response) {
        if (+ response.success === -1) {
          this.logOut(response.message);
        } else {
        // // console.log(response);
        this.avail_hours = response.hours;
      }
      } else {
        // console.log("error");
      }
    });
  }

  resetPassword() {
    const link = ['/changepassword'];
    this.router.navigate(link);
  }

  addHours(id) {
    // console.log(id);
    this.meetingService.GetSavedCards(this.authcode).subscribe(response => {
      if (response) {
        if (+ response.success === -1) {
          this.logOut(response.message);
        } else {
        if (response === '') {
          if (this.storage.get('select_city_id')) {
            const cid = this.storage.get('select_city_id');
            window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&city=' + cid, '_blank');
          } else {
            window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&city=0', '_blank');
          }
          // console.log("no saved card found");
        } else {
          this.storage.set('open_from_addhours', 'yes');
          setTimeout(function() {
              (<any>$('#myModal')).modal('show');
          }, 500);

        }
      }
      } else {
        // console.log("error");
      }
    });
  }

  getSavedCard() {
    // this.eventremember();
    if (this.storage.get('open_from_addhours') && this.storage.get('open_from_addhours') === 'yes') {
      // $('#saved_card').modal('hide');
      // var cardid = card.cardid;
      // var cvv = document.getElementById('cvv_'+cardid).value;
      // this.storage.set('cardid',cardid);
      // this.storage.set('cvvnum',cvv);
      const link = ['/makepayment'];
      this.router.navigate(link);
    }
  }

  addhoursqry(id) {
    // // console.log(id);
    // this.eventremember();
    const hour = document.getElementById('miss_hour').value;
    // // console.log(hour);

    let cid: any;

    if (this.storage.get('select_city_id')) {
      cid = this.storage.get('select_city_id');
    } else {
      cid = '0';
    }
    if (hour === 5) {
      window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&price2=1&city=' + cid, '_blank');
    } else if (hour === 15) {
      window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&price3=1&city=' + cid, '_blank');
    } else {
      window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&price1=' + hour + '&city=' + cid, '_blank');
    }

  }

  profileShow() {
    const link = ['/profile'];
    this.router.navigate(link);
  }

  cancel() {
    const link = ['/profile'];
    this.router.navigate(link);
  }

  signOut() {
    this.busy = this.meetingService.logout(this.authcode).subscribe(response => {
      if (response) {
        if (response[0].success === 1) {
          // // console.log(response);
          this.storage.remove('user');
          this.storage.remove('select_city');
          this.storage.remove('select_city_id');
          this.storage.remove('select_building');
          this.storage.remove('select_building_id');
          this.storage.remove('select_room');
          this.storage.remove('select_room_id');
          this.storage.remove('seats');
          this.authcode = null;
          this._cookieService.put('msg', response[0].message);
          const link = ['/login'];
          this.router.navigate(link);
          // this.delete_cookie('user');
          // window.location.href = "http://ovo.dev.bluelightit.com/?message=Logout%20Successful";
        } else {
          this.toasterService.pop('error', response[0].message);
        }
      } else {
        // console.log("error");
      }
    }, (err) => {
      this.signOut();
    });
    // let link = ['/login'];
    // this.router.navigate(link);
  }

  login() {
    const link = ['/login'];
    this.router.navigate(link);
  }

  logOut(message) {

          this.storage.remove('user');
          this.storage.remove('select_city');
          this.storage.remove('select_city_id');
          this.storage.remove('select_building');
          this.storage.remove('select_building_id');
          this.storage.remove('select_room');
          this.storage.remove('select_room_id');
          this.storage.remove('seats');
          this.authcode = null;
          this._cookieService.put('msg', message);
          const link = ['/login'];
          this.router.navigate(link);

  }


}
